export default "__VITE_ASSET__Cd18og$z__"